import React from "react";
import Header from "./header";
import ChallengeCard from "./ChallengeCard";
import MemberPositionList from "./MemberPositionList";
import ChallengeDetails from "./ChallengeDetails";
import { useChallengeDetails } from "../../api/challenges/queryHooks";
import { useParams } from "react-router-dom";
import { decodeId } from "../../api/utils";

function ChallengePage() {
  const id = decodeId(useParams()?.id);
  const { isError } = useChallengeDetails(id);

  if (isError) return <div>Not Found</div>;

  return (
    <>
      <Header />
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <ChallengeCard />
        <MemberPositionList />
      </div>
      <ChallengeDetails />
      <div className="h-[70px] lg:hidden"></div>
    </>
  );
}

export default ChallengePage;
